import axios from 'axios';
import authHeader from './auth-header';

const API_URL_V3 = process.env.REACT_APP_DOWNLOAD_SERVER;

// downloadFile.service.js
class DownloadFileService {
    getFiles(path) {
        const adjustedPath = path ? `${path}` : '';
        return axios.get(`${API_URL_V3}/files/list/${adjustedPath}`, {
            headers: authHeader()
        });
    }

    downloadFile(path, filename, options = {}) {
        const fullPath = path ? `${path}/${filename}` : filename;
        let url = `${API_URL_V3}/files/download/${fullPath}`;

        // Thêm query parameters nếu có
        if (options.token) url += `?token=${options.token}`;
        if (options.password) url += `?password=${options.password}`;
        // ... các options khác

        return url; // Trả về URL để redirect
    }

    generateShareToken(path, filename) {
        const fullPath = path ? `${path}/${filename}` : filename;
        return axios.get(`${API_URL_V3}/files/share-token/${fullPath}`, {
            headers: authHeader()
        });
    }

    createFolder(path, folderName) {
        const adjustedPath = path ? `${path}` : '';
        return axios.post(`${API_URL_V3}/files/create-folder/${adjustedPath}`,
            {
                data: folderName
            },
            {
                headers: authHeader()
            });
    }

    uploadFile(path, formData, onUploadProgress) {
        const adjustedPath = path ? `${path}` : '';
        return axios.post(`${API_URL_V3}/files/upload/${adjustedPath}`, formData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: onUploadProgress // Thêm lại callback progress
        });
    }

    async uploadFileChunked(path, file, onUploadProgress, signal) {
        const chunkSize = 50 * 1024 * 1024; // 50MB
        const totalChunks = Math.ceil(file.size / chunkSize);
        const adjustedPath = path ? `${path}` : '';
        let uploadedBytes = 0;

        for (let i = 0; i < totalChunks; i++) {
            if (signal && signal.aborted) {
                throw new DOMException('Upload cancelled', 'AbortError');
            }

            const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);

            const headers = {
                ...authHeader(),
                'Content-Type': 'application/octet-stream',
                'x-file-name': file.name,
                'x-chunk-index': i,
                'x-total-chunks': totalChunks,
            };

            try {
                await axios.post(`${API_URL_V3}/files/upload/${adjustedPath}`, chunk, {
                    headers,
                    signal,
                    onUploadProgress: (progressEvent) => {
                        const chunkProgress = progressEvent.loaded;
                        const totalUploaded = uploadedBytes + chunkProgress;
                        const totalProgress = Math.min(
                            Math.round((totalUploaded / file.size) * 100),
                            100
                        );
                        if (onUploadProgress) {
                            onUploadProgress({ loaded: totalUploaded, total: file.size, progress: totalProgress });
                        }
                    },
                });
                uploadedBytes += chunk.size;
            } catch (error) {
                if (error.name === 'AbortError' || error.name === 'CanceledError' || axios.isCancel(error)) {
                    console.log('Upload cancelled by user.');
                    throw error;
                }
                console.error(`Error uploading chunk ${i + 1} of ${totalChunks}`, error);
                throw error;
            }
        }

        console.log('File upload completed successfully.');
    }


    deleteFiles(path, items) {
        const adjustedPath = path ? `${path}` : '';
        return axios.delete(`${API_URL_V3}/files/delete/${adjustedPath}`, {
            headers: authHeader(),
            data: { items }
        });
    }

    getToolList() {
        return axios.get(`${API_URL_V3}/tools/list`, {
            headers: authHeader()
        });
    }

    updateFileRequireLoginTool(path, fileName, matool) {
        const adjustedPath = path ? `${path}` : '';
        return axios.put(`${API_URL_V3}/files/update-auth/${adjustedPath}`, {
            fileName,
            requireLoginTool: matool
        }, {
            headers: authHeader()
        });
    }

    // Whisper Manifest
    getWhisperManifest() {
        return axios.get(`${API_URL_V3}/whisper/manifest`);
    }

    updateWhisperManifest(manifest) {
        return axios.put(`${API_URL_V3}/whisper/manifest`, manifest, {
            headers: authHeader()
        });
    }

    // Piper Manifest
    getPiperManifest() {
        return axios.get(`${API_URL_V3}/piper/manifest`);
    }

    updatePiperManifest(manifest) {
        return axios.put(`${API_URL_V3}/piper/manifest`, manifest, {
            headers: authHeader()
        });
    }

    // CoquiTTS Manifest
    getCoquiManifest() {
        return axios.get(`${API_URL_V3}/coqui/manifest`);
    }

    updateCoquiManifest(manifest) {
        return axios.put(`${API_URL_V3}/coqui/manifest`, manifest, {
            headers: authHeader()
        });
    }

    // OmniVoice Manifest
    getOmniVoiceManifest() {
        return axios.get(`${API_URL_V3}/omnivoice/manifest`);
    }

    updateOmniVoiceManifest(manifest) {
        return axios.put(`${API_URL_V3}/omnivoice/manifest`, manifest, {
            headers: authHeader()
        });
    }

    // VocalRemover Manifest
    getVocalRemoverManifest() {
        return axios.get(`${API_URL_V3}/vocalremover/manifest`);
    }

    updateVocalRemoverManifest(manifest) {
        return axios.put(`${API_URL_V3}/vocalremover/manifest`, manifest, {
            headers: authHeader()
        });
    }
}

export default new DownloadFileService();